module.exports = __webpack_public_path__ + "img/studio-agency.6993f67e.png";